import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { connect } from 'react-redux';
import { fetchMe } from 'redux/users/actions';
import { patchUser, clearPatchUser } from 'redux/settings/actions';

import DashboardFormSection
  from 'components/dashboard/common/DashboardFormSection';
import CommonStanaloneInput
  from 'components/elements/inputs/CommonStanaloneInput';
import ProSectionPlaceholder
  from 'components/common/pro-placeholders/ProSectionPlaceholder';
import ProFeaturePlaceholder from 'components/common/ProFeaturePlaceholder';
import SensitiveMaterialForm
  from 'components/dashboard/settings-content/SensitiveMaterialForm';
import CustomDomainContent
  from 'components/dashboard/settings-content/CustomDomain/CustomDomainContent';
import ShareSettings
  from 'components/dashboard/settings-content/ShareSettings';
import ProLabel
  from 'components/common/ProLabel';
import CommerceSettings
  from 'components/dashboard/settings-content/commerce/CommerceSettings';

import './UserSettingsForm.css';
import validate from './validate';
import {Checkbox} from "semantic-ui-react";


class UserSettingsForm extends Component {
  static propTypes = {
    fetchMe: PropTypes.func.isRequired,
    patchUser: PropTypes.func.isRequired,
    clearPatchUser: PropTypes.func.isRequired,
    patchUserSuccess: PropTypes.object,
    patchUserError: PropTypes.object,
    me: PropTypes.object,
  };

  static defaultProps = {
    patchUserSuccess: null,
    patchUserError: null,
    me: null,
  };

  state = {
    utmEnabled: null,
  };

  onChangeUTMEnabled = (_e, { checked }) => {
    const form = new FormData();
    form.append('is_utm_enabled', checked);
    this.props.patchUser(form);
  };

  componentDidUpdate(prevProps) {
    if (
      !prevProps.patchUserSuccess &&
      prevProps.patchUserSuccess !== this.props.patchUserSuccess
    ) {
      this.props.fetchMe();
      setTimeout(() => {
        this.props.clearPatchUser();
      }, 500);
    }
  }

  renderPixelID = () => {
    const { me, patchUserError, patchUser } = this.props;
    return (
      <Translation>
        {(t) => (
          <>
            <div className="title-wrapper pro-feature">
              <span className="title">{t("Facebook Pixel")}</span>
              <a
                className="info-icon"
                href="https://blog.heylink.me/2020/11/03/how-to-use-facebook-pixel-on-heylink-me-in-2020/"
                target="_blank"
                rel="noopener noreferrer"
              />
              <ProLabel />
            </div>
            <ProSectionPlaceholder
              key="settings_form_input_field_key_pixel_id-pro-feature-key"
              locked={me && me.subscription && !me.subscription.ff_pixel_id}
              className="settings-pixel-id__component"
              text={
                <>
                  {t("You can add Facebook Pixel ID on the PRO plan. Check it")}
                </>
              }
            >
              <div className="fields-wrapper">
                <CommonStanaloneInput
                  key="settings_form_input_field_key_pixel_id"
                  fieldName="pixel_id"
                  label={t("Facebook Pixel ID")}
                  initValue={me.pixel_id}
                  validate={validate}
                  executedAction={patchUser}
                  patchError={patchUserError}
                />
              </div>
            </ProSectionPlaceholder>
          </>
        )}
      </Translation>
    );
  }

  renderTikTokPixelId = () => {
    const { me, patchUserError, patchUser } = this.props;
    return (
      <Translation>
        {(t) => (
          <>
            <div className="title-wrapper pro-feature">
              <span className="title">{t("TikTok Pixel")}</span>
              <a
                className="info-icon"
                href="https://blog.heylink.me/2021/04/30/how-to-use-tiktok-pixel-on-heylink-me-in-2021/"
                target="_blank"
                rel="noopener noreferrer"
              />
              <ProLabel />
            </div>
            <ProSectionPlaceholder
              key="settings_form_input_field_key_tiktok_pixel_id-pro-feature-key"
              locked={me && me.subscription && !me.subscription.ff_tiktok_pixel_id}
              className="settings-pixel-id__component"
              text={
                <>
                  {t("You can add TikTok Pixel ID on the PRO plan. Check it")}
                </>
              }
            >
              <div className="fields-wrapper">
                <CommonStanaloneInput
                  key="settings_form_input_field_key_tiktok_pixel_id"
                  fieldName="tiktok_pixel_id"
                  label={t("TikTok Pixel ID")}
                  initValue={me.tiktok_pixel_id}
                  validate={validate}
                  executedAction={patchUser}
                  patchError={patchUserError}
                />
              </div>
            </ProSectionPlaceholder>
          </>
        )}
      </Translation>
    );
  }

  render() {
    const { me, patchUserError, patchUser } = this.props;
    const { utmEnabled } = this.state;
    if (!me) return null;

    return (
      <Translation>
        {(t) => (
          <div className="user-settings-form__component">
            {/* Custom Domain */}
            <DashboardFormSection
              proLabel
              header={t("CUSTOM DOMAIN (WHITE-LABEL)")}
              infoUrl="https://blog.heylink.me/2020/10/15/how-to-add-custom-domain-white-label-on-heylink-me-in-2020/"
            >
              <CustomDomainContent />
            </DashboardFormSection>

            {/* COMMERCE SETTINGS */}
            <CommerceSettings />

            {/* SHARE SETTINGS */}
            <ShareSettings />

            {/* SEO */}
            <DashboardFormSection header={t("SEO")}>
              <div className="title-wrapper">
                <div className="title">{t("Custom Meta")}</div>
                <div className="subtext">
                  {t("Changes to meta may take some time to appear on other platforms.")}
                </div>
              </div>
              <div className="fields-wrapper">
                {/* Meta Title */}
                <CommonStanaloneInput
                  key="settings_form_input_field_key_meta_title"
                  fieldName="meta_title"
                  label={t("Title")}
                  initValue={me.meta_title}
                  validate={validate}
                  executedAction={patchUser}
                  patchError={patchUserError}
                />

                {/* Meta Description */}
                <CommonStanaloneInput
                  key="settings_form_input_field_key_meta_description"
                  fieldName="meta_description"
                  label={t("Description")}
                  initValue={me.meta_description}
                  validate={validate}
                  executedAction={patchUser}
                  patchError={patchUserError}
                />
              </div>
            </DashboardFormSection>

            {/* SENSITIVE MATERIAL */}
            <DashboardFormSection header={t("SENSITIVE MATERIAL")}>
              <SensitiveMaterialForm />
            </DashboardFormSection>

            {/* TRACKING (ANALYTICS) */}
            <DashboardFormSection header={t("TRACKING")}>
              {/* Facebook Pixel ID */}
              {this.renderPixelID()}

              {/* TikTok Pixel ID */}
              {this.renderTikTokPixelId()}

              {/* UTM */}
              <div className="title-wrapper utm-header-wrapper">
                <div className="title-pro-wrapper">
                  <div className="title">{t("UTM campaign")}</div>
                </div>

                <div className="utm-checkbox">
                  <div className="label">{t("OFF")}</div>
                  <Checkbox
                    toggle
                    checked={me.is_utm_enabled}
                    onChange={this.onChangeUTMEnabled}
                  />
                  <div className="label">{t("ON")}</div>
                </div>
              </div>

              <div className="fields-wrapper">
                <div className="description">
                  {t("Make Google Analytics show HeyLink.me traffic as " +
                    "'Social' Traffic. The campaign parameter is set " +
                    "dynamically from the title of each link.")}
                </div>

                {/* UTM Campaign */}
                {me.is_utm_enabled && (
                  <div className="utm-campaign-wrapper pro-feature">
                    <ProSectionPlaceholder
                      key="settings_form_input_field_key_utm_campaign-pro-feature-key"
                      locked={
                        me && me.subscription && !me.subscription.ff_utm_campaign
                      }
                      className="settings-pixel-id__component"
                      text={
                        <>
                          {t("You can add UTM campaign on the PRO plan. Check it")}
                        </>
                      }
                    >
                      <CommonStanaloneInput
                        key="settings_form_input_field_key_utm_campaign"
                        fieldName="utm_campaign"
                        label={t("UTM campaign")}
                        initValue={me.utm_campaign}
                        executedAction={patchUser}
                        patchError={patchUserError}
                      />
                      <ProLabel />
                    </ProSectionPlaceholder>
                  </div>
                )}
              </div>

              <div className="fields-wrapper">
                {/* UTM Medium */}
                {me.is_utm_enabled && (
                  <CommonStanaloneInput
                    key="settings_form_input_field_key_utm_medium"
                    fieldName="utm_medium"
                    label={t("Medium")}
                    initValue={me.utm_medium}
                    executedAction={patchUser}
                    patchError={patchUserError}
                  />
                )}

                {/* UTM Source */}
                {me.is_utm_enabled && (
                  <CommonStanaloneInput
                    key="settings_form_input_field_key_utm_source"
                    fieldName="utm_source"
                    label={t("Source")}
                    initValue={me.utm_source}
                    executedAction={patchUser}
                    patchError={patchUserError}
                  />
                )}
              </div>
            </DashboardFormSection>
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    patchUserSuccess: state.settingsReducer.patchUserSuccess,
    patchUserError: state.settingsReducer.patchUserError,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchMe,
    patchUser,
    clearPatchUser,
  },
)(UserSettingsForm);
